import React, { useMemo, useEffect } from 'react';
import {
  createBrowserRouter, RouterProvider
} from 'react-router-dom';
import { RouterListener } from '@m2h/common/Mach/modules/Router';
import { GlobalLoadingComponent } from '@m2h/common/Mach/modules/ActivityIndicator';
import useAMap from '@sailor/mp2h5-components-react/dist/components/Map/hooks/useAMap';
// import machInit from '@m2h/common/Mach/machInit';
import RouteElement from './RouteElement';
import config from './config';

// machInit();

const generateRoutes = (routeConfig: any, prefix = '') => {
  const routes: any[] = [];
  routeConfig.forEach((route) => {
    const routePath = `${prefix}${route.path}`;
    const curRoute = {
      ...route,
      path: routePath,
      key: routePath,
      element: <RouteElement key={routePath} {...route} />,
      children: route.children?.length > 0 ? generateRoutes(route.children, prefix) : [],
    };
    routes.push(curRoute);
  });
  return routes;
};

// const BUILD_ENV = 0 && process_env_BUILD_ENV;
const BUILD_ENV = process_env_BUILD_ENV;

// console.log(BUILD_ENV, 'BUILD_ENV');
export default function () {
  const routConfig = useMemo(() => (BUILD_ENV ? config : [...config]), [config]);

  const deepLoopRoutes = generateRoutes(routConfig);

  const router = createBrowserRouter(deepLoopRoutes);

  // const { loadAMap } = useAMap();
  // useEffect(() => {
  //   setTimeout(() => {
  //     loadAMap();
  //   }, 3300);
  // }, []);

  return (
    <>
      <GlobalLoadingComponent />
      {/* @ts-ignore */}
      <RouterProvider router={router}>
        <RouterListener />
      </RouterProvider>
    </>
  );
}
